import { useMutation, useQueryClient } from 'react-query'

import { type RepoError } from '@webapp/infrastructure/interfaces/repositories/RepoError'
import { creditCardItemRepository } from '@webapp/modules/accounts-payable/data-access/repositories/CreditCardItemRepository'
import {
  CREDIT_CARD_ITEM_LIST_BASE_KEY,
  CREDIT_CARD_ITEM_UNMATCHED_BASE_KEY,
} from '@webapp/modules/accounts-payable/query-configs/creditCardItemQueries'

export const useMutateArchiveCreditCardItem = () => {
  const queryClient = useQueryClient()

  const mutation = useMutation<void, RepoError, { id: number }>({
    mutationFn: ({ id }) => creditCardItemRepository.setArchived(id, true),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: CREDIT_CARD_ITEM_LIST_BASE_KEY,
      })
      queryClient.invalidateQueries({
        queryKey: CREDIT_CARD_ITEM_UNMATCHED_BASE_KEY,
      })
    },
  })

  return {
    archive: mutation.mutateAsync,
    isLoading: mutation.isLoading,
    error: mutation.error,
  }
}
